// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"797":"7f73fdff","1085":"7f73fdff","1293":"7f73fdff","4485":"7f73fdff","4929":"7f73fdff","5631":"7f73fdff","8712":"7f73fdff"}[chunkId] + ".chunk.css";
};